module.exports = __webpack_public_path__ + "static/opener-text-sml-7274d1b267100acdaf4406170b1c1b85.png";